import pick from "lodash/fp/pick";
import { pickTicketPoolFormFields } from "views/TicketTemplates/TicketTemplateCreate/utils";
import { GetEventTemplate } from "@ticketingplatform/api/dist/recurringEvent/__generated__/queries";

import { RecurringMode } from "../RecuringEventForm/Tabs/EventInfo/RecurringSettingsField/partials/RecurringSettingsForm/enums";
import { EventTemplateFormProps } from "../RecuringEventForm/types";

type GetEventTemplate_eventTemplate_recurringSettings = NonNullable<
  NonNullable<GetEventTemplate["eventTemplate"]>["recurringSettings"]
>;

const pickRecurringSettingsFormFields = pick([
  "endAt",
  "isOnMonday",
  "isOnTuesday",
  "isOnWednesday",
  "isOnThursday",
  "isOnFriday",
  "isOnSaturday",
  "isOnSunday",
  "maxOccurrences",
  "monthRepeatMode",
  "separator",
  "separatorCount",
]);

const pickPresalePasswordsFormFields = pick(["name", "password", "expireAt"]);

export const getRecurringSettingsMode = (
  recurringsSettings: GetEventTemplate_eventTemplate_recurringSettings | null
): RecurringMode | undefined => {
  if (!recurringsSettings) {
    return undefined;
  }

  const { endAt } = recurringsSettings;

  if (endAt) {
    return RecurringMode.END_AT;
  }

  return RecurringMode.MAX_OCCURRENCES;
};

export const parseEventDataToFormValues = (
  data: GetEventTemplate | null | undefined
): EventTemplateFormProps["initialValues"] => {
  if (!data?.eventTemplate) {
    return undefined;
  }

  const {
    recurringSettings,
    ticketPools,
    presalePasswords,
    discountCodes,
    image,
    __typename: _,
    seatMap,
    ...event
  } = data.eventTemplate;

  return {
    input: {
      ...event,
      seatMap: seatMap || undefined,
      image: image || undefined,
      discountCodes: discountCodes?.nodes,
      recurringSettings: {
        ...(recurringSettings
          ? pickRecurringSettingsFormFields(recurringSettings)
          : {}),
        mode: getRecurringSettingsMode(recurringSettings ?? null),
      },
      ticketPools: ticketPools?.nodes.map((ticketPool) => ({
        ...pickTicketPoolFormFields(ticketPool),
        id: ticketPool.id?.toString(),
        hasAnyTicketSold: false,
      })),
      presalePasswords: presalePasswords?.nodes.map((presalePassword) => ({
        ...pickPresalePasswordsFormFields(presalePassword),
        id: presalePassword.id.toString(),
      })),
    },
  };
};
